import { render } from "./eventsLog.vue?vue&type=template&id=16e8a7ee&scoped=true"
import script from "./eventsLog.vue?vue&type=script&lang=js"
export * from "./eventsLog.vue?vue&type=script&lang=js"

import "./eventsLog.vue?vue&type=style&index=0&id=16e8a7ee&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e8a7ee"]])

export default __exports__